import type { CurriculumRemovalNode } from "../services/curriculum.service";

/**
 * Scheduled removals first: a lesson leaving a student's schedule is the
 * consequence worth reading, and published-but-unassigned is comparatively
 * cheap.
 *
 * Split out of ConfirmRemovalsDialog rather than exported beside it: the dialog
 * portals, so it renders to nothing under the static-markup test harness, and a
 * component file that also exports helpers breaks fast refresh.
 */
export const orderRemovals = (
  nodes: CurriculumRemovalNode[] | null,
): CurriculumRemovalNode[] =>
  [...(nodes ?? [])].sort((a, b) => Number(b.scheduled) - Number(a.scheduled));

/** The line that tells the user what confirming actually costs. */
export const removalSummary = (
  nodes: CurriculumRemovalNode[] | null,
): string => {
  const assigned = orderRemovals(nodes).filter((node) => node.scheduled).length;
  if (assigned === 0) {
    return "These lessons are published but not assigned to anyone yet.";
  }
  // Pluralises on the assigned count, not the list length -- the number in the
  // sentence is the assigned one, so "1 of these are" was the alternative.
  return `${assigned} of these ${assigned === 1 ? "is" : "are"} already assigned to students and will be taken off their schedules.`;
};
